module.exports = __webpack_public_path__ + "img/map-marked-alt-solid.f889f960.svg";